import React, { Dispatch, useEffect } from 'react';
import PasswordDialog from './PasswordDialog/PasswordDialog';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../redux/store';
import MainWorkflowDialog from './MainDialog/MainWorkflowDialog';
import {
    closeInitialReleaseDialog,
    closeMainDialog,
    getDataForInitialReleaseDialog,
    getDataForMainDialog,
    openPasswordDialog,
    resetHasPassword,
} from '../../../../redux/project/sliceProjectWorkflow';
import InitialReleaseDialog from './InitialReleaseDialog/InitialReleaseDialog';
import { useParams } from 'react-router-dom';

export default () => {
    const isPasswordDialogOpen = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow.isPasswordDialogOpen,
    );

    const isMainDialogOpen = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow.isMainDialogOpen,
    );

    const isInitialReleaseDialogOpen = useSelector(
        (_store: IAppReduxStore) => _store.projectWorkflow.isInitialReleaseDialogOpen,
    );

    const hasPassword = useSelector((_store: IAppReduxStore) => _store.projectWorkflow.hasPassword);

    const selectedProjectDocumentIds = useSelector(
        (_store: IAppReduxStore) => _store.projectSelectedDocuments.storage.documentIds,
    );

    const selectedImportDocumentIds = useSelector(
        (_store: IAppReduxStore) => _store.projectSelectedDocuments.storage.documentIds,
    );

    /** Get the replicaId from the react router. */
    const { replicaId, areaName } = useParams();

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    useEffect(() => {
        if (hasPassword === false) {
            // DB has no password, open correct dialog
            areaName === 'import'
                ? dispatch(
                      getDataForInitialReleaseDialog({
                          replicaId,
                          documentIds: selectedImportDocumentIds,
                      }),
                  )
                : dispatch(
                      getDataForMainDialog({ replicaId, documentIds: selectedProjectDocumentIds }),
                  );
        }
        dispatch(resetHasPassword());
    }, [hasPassword]);

    return (
        <>
            <MainWorkflowDialog
                open={isMainDialogOpen}
                onClose={() => dispatch(closeMainDialog())}
            />

            <PasswordDialog
                open={isPasswordDialogOpen}
                onClose={() => dispatch(openPasswordDialog(false))}
            />

            <InitialReleaseDialog
                open={isInitialReleaseDialogOpen}
                onClose={() => dispatch(closeInitialReleaseDialog())}
            />
        </>
    );
};
